<style lang="scss" scoped>
.font-weight {
    font-weight: 800;
}
</style>
<template>
    <div>
        <compWrapper title="基本信息" theme="primary">
            <compFormQuery
                v-if="type=='query'"
                class="margin-layout width-50per"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
                placeholder="--"
                :col="1"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-layout width-50per"
                ref="supplierEditForm"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
                :col="1"
            />
        </compWrapper>
        <!-- 仓库列表 -->
        <compWrapper title="仓库列表" theme="info">
			<compCusWare class="margin-layout" ref="channelIds" :waredata="waredatalist" :custype="type" :wareOrgid="activeid"></compCusWare>
		</compWrapper>

        <div class="text-right padding-bottom-20" v-if="type!='query'">
            <Button type="primary" @click="submit">保存</Button>
            <Button class="margin-left-10" @click="cancel">取消</Button>
        </div>

        <!-- 操作历史 -->
        <compWrapper title="操作历史" theme="gray" v-if="type=='query'">
            <compLog :data="logList" ></compLog>
        </compWrapper>

        <vLoading size="large" transfer :loading="loading"></vLoading>

    </div>
</template>

<script>
import { mapState,mapGetters } from "vuex";
import { HttpQueryBillTypeOne, HttpSaveBilltypeOne } from "@/service/newbigaccount";

import compCusWare from "./cusware";

// 搜索品类

import mixin from '../mixin'
export default {
    mixins: [mixin],
    props:['activeid','querytype'],
    data(){
        return {
            type: this.$route.params.type || this.querytype,
            id: this.$route.query.id || this.activeid,
            formData:{},
            logList:[],
            waredatalist:[],
            loading:false,
        }
    },
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compCusWare,
	},
    created(){
        this.update();

    },
    computed:{
        ...mapGetters('dictionary', ['getCusBillTypeList']),
        getBase(){
            return [
                {
                    label: "费用类型",
                    tag:'vSelect',
                    key:'expenseCategoryType',
                    options:this.getCusBillTypeList,
                    query:this.type!='add',

                },
                {
                    label:'自定义名称',
                    key:'name',
                    required:false,
                },
                {
					label: "费用类型代码",
					key: "code",
                    show:this.type!='add',
                    query:true
				},

                {
					label: '状态',
					key: 'status',
					tag: 'vRadio',
					show: this.isSuper,
					props: {
						strict: false,
					},
					options: [{
						trueValue: 0,
						label: '启用'
					}, {
						trueValue: 1,
						label: '禁用'
					}]
				},

                {
                    label: "订单类型",
                    tag:'vSelect',
                    key:'orderType',
                    props: {
                        multiple: true
                    },
                    options:this.getOrderList,
                    show:this.formData.expenseCategoryType == 0,
                    // 查看
                    render: (h) => {
                        if(this.formData.orderType){
                            let orderType = this.formData.orderType.map(item => {
                                return this.getOrderList.filter(sitem => {
                                    return sitem.value == item
                                })[0].label;
                            });
                            orderType = orderType.join(',');
                            return <div>{orderType}</div>
                        }else{
                            return <div>--</div>
                        }
                    }
                },

                {
					label: "备注",
					key: "remark",
                    tag: "vTextarea",
                    required:false,
                },
            ]
        },
    },
    methods:{
        update(){
            if(this.type == 'add') return
            // 日志
            // if(this.type == 'query'){
            //     HttpSysOpLog({
            //         'search[EQ_opData]':this.id,
            //         'search[EQ_opModel]':'Product_Development_Recommend',
            //         row:1000,
            //         page:1,
            //     }).then(res=>{
            //         this.logList = res.data.content
            //     },err=>{
            //     })
            // }
            this.loading = true;
            HttpQueryBillTypeOne({
                id:this.id
            }).then(res=>{
                this.formData = res.data;
                if(this.formData.expenseCategoryType == 0 && this.formData.orderType){
                    this.formData.orderType = res.data.orderType.split(',');
                    this.formData.orderType = this.formData.orderType.map(item => {
                        return parseInt(item);
                    });
                }
                this.waredatalist = res.data.expenseCategoryWarehouses;
                // console.log('orderType', this.formData.orderType);

                this.loading = false;
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                this.loading = false;
            })
        },
        async submit(typesta){
            let flag = false
            await this.$refs.supplierEditForm.validate(valid => {
                if (!valid) return flag = true
            })
            if (flag) return this.$VMessage.error('请填写必填项');

            // console.log(this.formData)
            this.formData.warehouseIds = this.$refs.channelIds.targetKeys.join(',')
            this.formData.expenseCategoryName = this.getCusBillTypeList.filter(item=>{ return item.value === this.formData.expenseCategoryType})[0].label

            if(this.formData.expenseCategoryType == 0 && this.formData.orderType){
                this.formData.orderType = this.formData.orderType.join(',');
            }
            this.loading = true;

            HttpSaveBilltypeOne({
                orgId:global.SYSID,
                id:this.formData.id,
                status:this.formData.status,
                expenseCategoryId:this.formData.expenseCategoryType,
                expenseCategoryType:this.formData.expenseCategoryType,
                expenseCategoryName:this.formData.expenseCategoryName,
                name:this.formData.name,
                orderType:this.formData.orderType || '',
                remark:this.formData.remark,
                warehouseIds:this.formData.warehouseIds,
                billingChannel: 'PAYABLE',
                // ...this.formData,
            }).then(res=>{
                this.$Message.success(res.message);
                this.cancel()
                this.loading = false;
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                this.loading = false;
            })
        },

        cancel(){
            this.$router.push({
                name: 'payStoreBillType',
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.other-form {
    .form-item {
        height: 42px;
        margin-bottom: 5px;
        clear: both;
    }
}
</style>

